import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ApplicationList } from "@/components/admin/ApplicationList";
import { SiteContentManager } from "@/components/admin/SiteContentManager";
import { NumberManager } from "@/components/admin/NumberManager";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { AdminHeader } from "@/components/admin/AdminHeader";
import { toast } from "sonner";

const Admin = () => {
  const [numbers, setNumbers] = useState<any[]>([]);
  const [applications, setApplications] = useState<any[]>([]);
  const [siteContent, setSiteContent] = useState<any[]>([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuth();
    window.addEventListener('storage', checkAuth);
    return () => {
      window.removeEventListener('storage', checkAuth);
    };
  }, []);

  const checkAuth = () => {
    console.log("Checking auth status");
    const auth = localStorage.getItem('adminAuthenticated');
    console.log("Auth status:", auth);
    setIsAuthenticated(auth === 'true');
    setIsLoading(false);
  };

  const fetchNumbers = async () => {
    console.log("Fetching numbers");
    const { data, error } = await supabase
      .from('cert_applications')
      .select('*')
      .is('applicant_name', null)
      .order('created_at', { ascending: false });

    if (error) {
      console.error("Error fetching numbers:", error);
      toast.error("获取号码列表失败");
    } else {
      console.log("Numbers fetched:", data?.length);
      setNumbers(data || []);
    }
  };

  const fetchApplications = async () => {
    console.log("Fetching applications");
    const { data, error } = await supabase
      .from('cert_applications')
      .select('*')
      .not('applicant_name', 'is', null)
      .order('created_at', { ascending: false });

    if (error) {
      console.error("Error fetching applications:", error);
      toast.error("获取申请列表失败");
    } else {
      console.log("Applications fetched:", data?.length);
      setApplications(data || []);
    }
  };

  const fetchSiteContent = async () => {
    console.log("Fetching site content");
    const { data, error } = await supabase
      .from('site_content')
      .select('*')
      .order('key');

    if (error) {
      console.error("Error fetching site content:", error);
      toast.error("获取网站内容失败");
    } else {
      console.log("Site content fetched:", data?.length);
      setSiteContent(data || []);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchNumbers();
      fetchApplications();
      fetchSiteContent();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return <AdminLogin onLogin={() => setIsAuthenticated(true)} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a1c2e] to-[#2d1b4b] text-white">
      <AdminHeader onLogout={() => setIsAuthenticated(false)} />
      
      <div className="container mx-auto px-4 py-8">
        <Tabs defaultValue="applications" className="space-y-6">
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="applications">认证申请</TabsTrigger>
            <TabsTrigger value="numbers">号码管理</TabsTrigger>
            <TabsTrigger value="content">内容管理</TabsTrigger>
          </TabsList>

          <TabsContent value="applications" className="bg-white/5 backdrop-blur-lg rounded-lg p-6">
            <ApplicationList 
              applications={applications}
              onUpdate={fetchApplications}
            />
          </TabsContent>

          <TabsContent value="numbers" className="bg-white/5 backdrop-blur-lg rounded-lg p-6">
            <NumberManager 
              numbers={numbers}
              onUpdate={fetchNumbers}
            />
          </TabsContent>

          <TabsContent value="content" className="bg-white/5 backdrop-blur-lg rounded-lg p-6">
            <SiteContentManager 
              content={siteContent}
              onUpdate={fetchSiteContent}
            />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default Admin;